import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogConfig } from '@angular/material';
import { CustomDateComponent } from '../../reports/customdate/custom-date.component';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var PumpgatewayreportComponent = /** @class */ (function () {
    function PumpgatewayreportComponent(ngxLoader, pumpservice, matDialog) {
        this.ngxLoader = ngxLoader;
        this.pumpservice = pumpservice;
        this.matDialog = matDialog;
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.columns = ['Deviceid', 'Date', 'Pumpid'];
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
    }
    PumpgatewayreportComponent.prototype.ngOnInit = function () {
        this.ngxLoader.startLoader('reportdata');
        this.timeFilter = {
            type: "Today",
            startDate: "",
            endDate: ""
        };
        ;
        this.getpumpIds();
    };
    PumpgatewayreportComponent.prototype.getpumpIds = function () {
        var _this = this;
        var data = { "roleid": this.currentUserData.roleid, "userid": this.currentUserData.userid };
        this.pumpservice.getPumpIds(data).subscribe(function (response1) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                console.log("ksajdhgsatdashbksankdasdvasuhjdinasuhda", response1.result);
                if (response1.result.length > 0) {
                    this.pumpIdsArray = response1.result.map(function (pump) { return pump.pump_id; });
                    this.idFilter = this.pumpIdsArray[0];
                    this.filters("pumpid", this.idFilter);
                }
                return [2 /*return*/];
            });
        }); });
    };
    PumpgatewayreportComponent.prototype.filters = function (type, value) {
        var _this = this;
        this.ngxLoader.startLoader('reportdata');
        if (type === "pumpid") {
            this.idFilter = value;
        }
        else {
            console.log("lakskdsa", value);
            if (value === "Custom") {
                console.log('Custom filter:', value);
                var dialogConfig = new MatDialogConfig();
                var dialogRef = this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px',
                    width: '450px',
                    data: {
                        "details": "",
                        "action": "Add",
                        selectedDate: this.customeSelectedDate
                    }
                });
                dialogRef.afterClosed().subscribe(function (selectedValue) {
                    if (selectedValue) {
                        _this.customeSelectedDate = selectedValue;
                        _this.timeFilter = {
                            type: value,
                            startDate: selectedValue.startDate,
                            endDate: selectedValue.endDate
                        };
                    }
                });
            }
            else {
                this.timeFilter = {
                    type: value,
                    startDate: "",
                    endDate: ""
                };
            }
        }
        var data = { "pumpid": this.idFilter, "duration": this.timeFilter };
        this.pumpservice.gatewayReport(data).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data_1;
            return tslib_1.__generator(this, function (_a) {
                if (response.result.length > 0) {
                    this.reportColumns = this.columns.concat(response.columns);
                    data_1 = [];
                    response.result.forEach(function (element) { data_1.push(JSON.parse(element.pumpreadings)); });
                    data_1.forEach(function (element) {
                        console.log(element);
                        if (element.pumpdplow == 0) {
                            element.pumpdplow = "LOW";
                        }
                        else if (element.pumpdplow == 1) {
                            element.pumpdplow = "HEALTHY";
                        }
                        if (element.AB_Switch_On_Feedback == 0) {
                            element.AB_Switch_On_Feedback = "OPERATED";
                        }
                        else if (element.AB_Switch_On_Feedback == 1) {
                            element.AB_Switch_On_Feedback = "INLINE";
                        }
                        if (element.Lighting_Transformer_On_Feedback == 0) {
                            element.Lighting_Transformer_On_Feedback = "OFF";
                        }
                        else if (element.Lighting_Transformer_On_Feedback == 1) {
                            element.Lighting_Transformer_On_Feedback = "ON";
                        }
                        element.pumpcurrent = ((element.L1 + element.L2 + element.L3) / 3).toFixed(2);
                        if (element.pumponffeedback == 0) {
                            element.pumponffeedback = "OFF";
                            element.pumpcurrent = 0;
                        }
                        else if (element.pumponffeedback == 1) {
                            element.pumponffeedback = "ON";
                        }
                    });
                    this.dataSource = new MatTableDataSource(data_1);
                    this.data = data_1;
                    console.log(" let data = [];", this.data);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    this.ngxLoader.stopLoader('reportdata');
                }
                this.ngxLoader.stopLoader('reportdata');
                return [2 /*return*/];
            });
        }); });
    };
    PumpgatewayreportComponent.prototype.formatData = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var dataArr = [];
            dataArr.push(_this.reportColumns);
            data.forEach(function (element) {
                dataArr.push(Object.values(element));
            });
            resolve(dataArr);
        });
    };
    PumpgatewayreportComponent.prototype.exportToPdfs = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, docDefinition;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.formatData(this.data)];
                    case 1:
                        _a.reportData = _b.sent();
                        console.log('Formatted Data:', this.reportData);
                        docDefinition = {
                            info: {
                                title: 'Transformer Report',
                            },
                            pageOrientation: 'portait',
                            pageSize: 'A0',
                            content: [
                                {
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 1,
                                        widths: ['10%', '10%', '10%', '10%', '10%'],
                                        //   body: [
                                        //      "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                                        //     [ "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                                        //    // [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
                                        //   ]
                                        body: this.reportData,
                                    }
                                }
                            ]
                        };
                        // const documentDefinition = { content: 'This is for testing.' };
                        pdfMake.createPdf(docDefinition).download();
                        return [2 /*return*/];
                }
            });
        });
    };
    PumpgatewayreportComponent.prototype.refreshData = function () {
        this.ngOnInit();
    };
    PumpgatewayreportComponent.prototype.columnNames = function (col) {
        switch (col) {
            case 'pumpcurrent':
                return 'Current';
            case 'motordetemperature':
                return 'Motor DE Temp';
            case 'motorndetemperature':
                return 'Motor NDE Temp';
            case 'motorrphasetemperature':
                return 'Motor R Phase Temp';
            case 'motoryphasetemperature':
                return 'Motor Y Phase Temp';
            case 'motorbphasetemperature':
                return 'Motor B Phase Temp';
            case 'pumponffeedback':
                return 'Pump Feedback';
            case 'pumpdplow':
                return 'Pump DP Low';
            default:
                return col;
        }
    };
    return PumpgatewayreportComponent;
}());
export { PumpgatewayreportComponent };
